(() => {
  const ok = document.getElementById('mep-ok'), form = document.getElementById('mep-form'), hint = document.getElementById('mep-hint');
  if (ok && hint) {
    const show = () => hint.classList.add('on');
    ok.addEventListener('invalid', show);
    if (form) form.addEventListener('submit', (e) => { if (!ok.checked) { e.preventDefault(); show(); ok.focus(); } });
    ok.addEventListener('change', () => { if (ok.checked) hint.classList.remove('on'); });
  }
  // Móvil: la barra con el precio se ve siempre que la tarjeta de compra no está en pantalla
  const stick = document.getElementById('mep-stick'), buy = document.getElementById('comprar');
  if (!stick || !buy || !('IntersectionObserver' in window)) return;
  const link = stick.querySelector('a');
  new IntersectionObserver(es => es.forEach(e => { const on = !e.isIntersecting; stick.classList.toggle('on', on); stick.setAttribute('aria-hidden', on ? 'false' : 'true'); link.tabIndex = on ? 0 : -1; })).observe(buy);
})();